import ConfirmDialog from 'further-ui/components/ConfirmDialog';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
};

const PendingDraftEqualisationsModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onClose}
      title="Draft equalisation deletion"
      content="This vehicle has a pending draft equalisation. If you save this action, the draft will be deleted."
      loading={loading}
      actions={{
        confirm: {
          onClick: onConfirm,
          label: 'Confirm',
        },
        cancel: {
          onClick: onClose,
        },
      }}
    />
  );
};

export default PendingDraftEqualisationsModal;
